import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { COLORS, paperSx, scrollSx } from '../pages/rejestracja/formTheme';

// Dialog shell for the content pages (terms, contact, confirmations): same look as
// the booking dialog. Sticky title + optional footer, only the body scrolls.
export default function PageDialog({
  title,
  children,
  actions,
  maxWidth = 900,
  onClose,
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useParams();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const close =
    onClose ?? (() => navigate(`/${lang}`, { state: { from: location } }));

  return (
    <Dialog
      open
      onClose={close}
      fullScreen={fullScreen}
      fullWidth
      maxWidth={false}
      slotProps={{ paper: { sx: paperSx({ fullScreen, maxWidth }), elevation: 6 } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
          pb: 1.5,
          borderBottom: `1px solid ${COLORS.border}`,
        }}
      >
        <Typography variant='h6' component='span' sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        <IconButton
          onClick={close}
          aria-label='Close'
          sx={{ color: 'white', mr: -1 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          flex: 1,
          p: fullScreen ? 2 : 4,
          // MUI zeroes the top padding of content that follows a title; override it
          '&&&': { pt: fullScreen ? 3 : 4 },
          ...scrollSx,
        }}
      >
        {children}
      </DialogContent>

      {actions && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1,
            p: 2,
            borderTop: `1px solid ${COLORS.border}`,
          }}
        >
          {actions}
        </Box>
      )}
    </Dialog>
  );
}
